import { render, staticRenderFns } from "./DemoDenied.vue?vue&type=template&id=20e9fdd4&"
import script from "./DemoDenied.vue?vue&type=script&lang=js&"
export * from "./DemoDenied.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports